module.exports = __webpack_public_path__ + "static/hoivakotilive_slide_1-31cc423c4327b34e4bc85b4b993ead15.jpg";